var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',{staticClass:"title"},[_vm._v("Edit Src: "+_vm._s(_vm.user.user_name))]),_c('cluster-teams')],1)}
var staticRenderFns = []

export { render, staticRenderFns }